import React from "react";
import Paper from "@material-ui/core/Paper";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Box from "@material-ui/core/Box";
import SettingsIcon from "@material-ui/icons/Settings";
import ListAltIcon from "@material-ui/icons/ListAlt";
import FieldsSelector from "./FieldsSelector";
import SettingsSelector from "./SettingsSelector";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Box
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      flex="1 1 0%"
      minWidth={0}
      maxWidth="100%"
      {...other}
    >
      {value === index && (
        <Box p={{ xs: 1, sm: 2 }} width="100%" minWidth={0} boxSizing="border-box">
          {children}
        </Box>
      )}
    </Box>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    display: "flex",
    flexGrow: 1,
    width: "100%",
    minWidth: 0,
    maxWidth: "100%",
    minHeight: 224,
    height: "100%",
  },
  tabs: {
    borderRight: `1px solid ${theme.palette.divider}`,
    flexShrink: 0,
    width: 100,
  },
  tab: {
    minWidth: 100,
    width: 100,
    minHeight: 36,
    fontSize: "0.8rem",
    padding: "6px 12px",
  },
  tabLabel: {
    display: "flex",
    alignItems: "center",
    width: "100%",
  },
  icon: {
    marginRight: theme.spacing(1),
  },
}));

const FormSettingsContainer = ({ setIsSetting }) => {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);

  const handleChange = (_, newValue) => {
    setValue(newValue);
    if (newValue === 1) {
      setIsSetting(true);
    } else {
      setIsSetting(false);
    }
  };

  return (
    <Paper elevation={0}>
      <Box className={classes.root}>
        <Tabs
          orientation="vertical"
          variant="scrollable"
          value={value}
          onChange={handleChange}
          aria-label="Vertical tabs example"
          className={classes.tabs}
        >
          <Tab
            label={
              <Box className={classes.tabLabel}>
                <ListAltIcon className={classes.icon} fontSize="small" />
                <span>فیلد‌ها</span>
              </Box>
            }
            {...a11yProps(0)}
            classes={{ root: classes.tab }}
          />
          <Tab
            label={
              <Box className={classes.tabLabel}>
                <SettingsIcon className={classes.icon} fontSize="small" />
                <span>تنظیمات</span>
              </Box>
            }
            {...a11yProps(1)}
            classes={{ root: classes.tab }}
          />
        </Tabs>
        <TabPanel value={value} index={0}>
          <FieldsSelector />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <SettingsSelector />
        </TabPanel>
      </Box>
    </Paper>
  );
};

export default FormSettingsContainer;
